import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { UserRole } from '@core/models/enums/user-role.enum';
import { LocalStorageService } from '@core/services/local-storage.service';

export namespace esnAbonneNonabonneeGuard {
  export const canActivate: CanActivateFn = () => {
    const _localStorageService = inject(LocalStorageService);
    const _router = inject(Router);

    const companyRoleId = _localStorageService.getData('roleUseresnnonabonne');
    const companyRoleIdclient = _localStorageService.getData('roleUserclient');
    const typeintervenant = _localStorageService.getData('typeintervenant');
    
    if (companyRoleId === UserRole.ESN_UNSUBSCRIBED || 
        companyRoleIdclient=== UserRole.ADMIN_ESN 
        || typeintervenant==='2') {
      return true;  
    } else {
      _router.navigate(['/404']); 
      return false;  
    }
  };
  export const canActivateChild: CanActivateChildFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) => canActivate(route, state);
}
